import React from 'react';
import { Link } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

function CartPopup (props) {
/*
  return (
    <div className="AW-cookie-consent " style={{ display: "block" }}>
      <p>{props.text}</p>
      <Link to="/carrello">
        <div
          className="AW-cookie-consent-button"
         >
          Vai al carrello
        </div>
      </Link>
      <div
        className="AW-cookie-consent-button"
        onClick={(e) => props.closeHandler()}
      >
        Chiudi
      </div>
    </div>
  );
*/
  return (
    <Dialog open={true}>
      <DialogTitle>{props.titletext}</DialogTitle>
      <DialogTitle>{props.text}</DialogTitle>
      <DialogContent>
        <Link to="/carrello">
          <div className="carrello_popup_button">Vai al carrello</div>
        </Link>
        <div
          className="acquisti_popup_button"
          onClick={(e) => props.closeHandler()}
        >
          Continua gli acquisti
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CartPopup;